import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DeleteIcon: FC<SvgIconProps> = props => {
  return (
    <SvgIcon
      {...props}
      sx={{
        fill: 'none',
        width: '24px',
        height: '24px',
        ...props?.sx,
      }}
    >
      <path
        d='M4.64889 9.90948C4.58188 9.03829 5.27071 8.29443 6.14447 8.29443H17.5925C18.4663 8.29443 19.1551 9.03829 19.0881 9.90948L18.2698 20.5481C18.2097 21.3296 17.558 21.933 16.7742 21.933H6.96283C6.17902 21.933 5.52736 21.3296 5.46724 20.5481L4.64889 9.90948Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M19.7368 5.14746H4'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M9.77026 3C9.77026 2.44772 10.218 2 10.7703 2H12.9667C13.519 2 13.9667 2.44772 13.9667 3V5.14736H9.77026V3Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M13.9666 12.4912V17.7368'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M9.77026 12.4912V17.7368'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </SvgIcon>
  );
};

export default DeleteIcon;
